package com.swetdot.swetgram.ui.design

/** Width classes follow the common 600dp and 840dp adaptive-layout breakpoints. */
enum class SwetWidthClass { Compact, Medium, Expanded }

data class SwetLayoutRules(
    val widthClass: SwetWidthClass,
    val isLandscape: Boolean,
    val useTwoColumns: Boolean,
    val useTwoPaneChats: Boolean,
)

fun swetLayoutRules(widthDp: Int, heightDp: Int): SwetLayoutRules {
    require(widthDp > 0 && heightDp > 0) { "window dimensions must be positive" }
    val widthClass = when {
        widthDp < 600 -> SwetWidthClass.Compact
        widthDp < 840 -> SwetWidthClass.Medium
        else -> SwetWidthClass.Expanded
    }
    return SwetLayoutRules(
        widthClass = widthClass,
        isLandscape = widthDp > heightDp,
        useTwoColumns = widthClass != SwetWidthClass.Compact,
        useTwoPaneChats = widthClass == SwetWidthClass.Expanded,
    )
}
